import React from 'react';
import { Outlet } from 'react-router-dom';
import Layout from '../Components/Layout';
import styles from './candidatePortal.module.scss';

export function CandidatePortal() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}
